import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Wallet, ArrowLeftRight, BarChart3, LogOut, Building2, BedDouble } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/", label: "Kontrol Paneli", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/rezervasyonlar", label: "Rezervasyonlar", icon: BedDouble, testid: "nav-rezervasyonlar" },
  { to: "/cariler", label: "Cari Hesaplar", icon: Users, testid: "nav-cariler" },
  { to: "/hesaplar", label: "Kasa & Banka", icon: Wallet, testid: "nav-hesaplar" },
  { to: "/hareketler", label: "Tüm Hareketler", icon: ArrowLeftRight, testid: "nav-hareketler" },
  { to: "/raporlar", label: "Raporlar", icon: BarChart3, testid: "nav-raporlar" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => {
    await logout();
    navigate("/giris");
  };

  return (
    <aside className="w-64 border-r border-border bg-[#F8F7F3] h-screen fixed left-0 top-0 flex flex-col">
      <div className="px-6 py-6 border-b border-border">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-md bg-primary text-primary-foreground flex items-center justify-center">
            <Building2 className="w-4 h-4" />
          </div>
          <div>
            <div className="font-heading font-semibold text-[15px] text-foreground leading-none">Turizm Finans</div>
            <div className="text-[11px] text-foreground/50 mt-1 tracking-wider uppercase">Nakit & Cari</div>
          </div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === "/"}
            data-testid={l.testid}
            className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
          >
            <l.icon className="w-4 h-4" strokeWidth={1.75} />
            <span>{l.label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-3 pb-4 border-t border-border pt-4">
        <div className="px-3 pb-3">
          <div className="text-[11px] text-foreground/50 tracking-wider uppercase">Giriş yapan</div>
          <div className="text-sm text-foreground truncate" data-testid="sidebar-user-name">{user?.name || user?.email}</div>
        </div>
        <button
          onClick={handleLogout}
          data-testid="logout-button"
          className="sidebar-link w-full text-left hover:bg-destructive/10 hover:text-destructive"
        >
          <LogOut className="w-4 h-4" strokeWidth={1.75} />
          <span>Çıkış Yap</span>
        </button>
      </div>
    </aside>
  );
}
